import { Flex, Stack } from '@chakra-ui/react'
import { H5 } from 'components/typography'
import { useRouter } from 'next/router'
import { FC } from 'react'

const MedleveBanner: FC = () => {
  const { pathname } = useRouter()
  const gads = pathname.includes('gads')
  return (
    <Stack
      align="center"
      justify="center"
      w="full"
      gap={4}
      direction={'column'}
      pt={6}
      px={6}
      bg={'alabaster'}
      color={'medleve'}
    >
      <Flex justify={'space-between'} align={'center'} gap={4}>
        <Stack bg={'white'} w={'160px'} py={4} px={2} h={'90px'} justify={'center'} borderRadius={'lg'}>
          <H5 textAlign={'center'}>{gads ? 'Consulta sem agendamento' : 'Acompanhamento médico 100% online'}</H5>
        </Stack>
        <Stack bg={'white'} w={'160px'} p={4} h={'90px'} justify={'center'} borderRadius={'lg'}>
          <H5 textAlign={'center'}>{gads ? 'Atendimento 100% online' : 'Sem filas e sem burocracia'}</H5>
        </Stack>
      </Flex>
      <Flex justify={'space-between'} align={'center'} gap={4}>
        <Stack bg={'white'} w={'160px'} p={4} h={'90px'} justify={'center'} borderRadius={'lg'}>
          <H5 textAlign={'center'}>
            {gads ? 'Melhores especialistas do Brasil' : 'Receba sua recomendação digitalmente'}
          </H5>
        </Stack>
        <Stack bg={'white'} w={'160px'} p={4} h={'90px'} justify={'center'} borderRadius={'lg'}>
          <H5 textAlign={'center'}>Baixe sua receita assinada digitalmente</H5>
        </Stack>
      </Flex>
    </Stack>
  )
}

export default MedleveBanner
